export default (
  email: string,
  index: number,
  removeEmail: (index: number) => void
) => {
  const onClick = (e: any) => {
    e.stopPropagation()
    removeEmail(index)
  }
  return (
    <div className="bg-white" data-tag key={`${index}-${email}`}>
      {email}
      <span data-tag-handle onClick={onClick}>
        ×
      </span>
    </div>
  )
}
